import { useEffect } from "react";
import { useSettings } from "../context/SettingsContext";
import { usePremium } from "../context/PremiumContext";
import { FREE_TRANSLATIONS } from "../api";

// Non-premium in-app users can't stay on a premium translation (e.g. NKJV);
// silently downgrade them to NLT (the default free translation).
export default function TranslationGuard() {
  const { translation, setTranslation } = useSettings();
  const { isPremium, inApp } = usePremium();
  useEffect(() => {
    if (inApp && !isPremium && !FREE_TRANSLATIONS.includes(translation)) {
      setTranslation("NLT");
    }
  }, [inApp, isPremium, translation, setTranslation]);
  return null;
}
